import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { FirmWareUpdateActionTypes, FirmWareUpdateActions } from '../actions/firm-ware-update.actions';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {FirmWareService} from '../../../services/firm-ware.service';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';


@Injectable()
export class FirmWareUpdateEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private firmWareService = inject(FirmWareService);

  constructor() {}

  getFirmWareUpdates$ = createEffect(() => this.actions$.pipe(
    ofType(FirmWareUpdateActionTypes.GetFirmWareUpdates),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        data: action.payload
      };
      return this.firmWareService.UpgradeFirmware(params).pipe(
        switchMap(res => {
          const result = { ...res, type: updateInfoType.UpgradeFirmWare };
          if (result.result) {
            return [new featureActions.UpdateInfoSuccessAction(result), new featureActions.LoadFirmWareUpdates()];
          } else {
            return [new featureActions.UpdateInfoFailAction(result), new featureActions.LoadFirmWareUpdates()];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.UpgradeFirmWare
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));

}
